import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StatusComponent } from './status.component';
import { TranslateModule } from '@ngx-translate/core';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';

@NgModule({
  declarations: [
    StatusComponent
  ],
  imports: [
    CommonModule,
    TranslateModule,
    MatMenuModule,
    MatTooltipModule
  ],
  exports: [
    StatusComponent
  ]
})
export class StatusModule {}
